<template>
  <div>
    <b-card title="Pass Rates" title-tag="h2" class="text-center">
      <b-card-text>
        <div class>
          <table
            class="table table-sm small"
            aria-labelledby="passRatesTableLabel"
          >
            <!-- <caption v-if="pricingDescriptions" class="card">
            <span v-for="(description, index) in pricingDescriptions[0].paragraphs" :key="index">            
              {{description}} <br/>          
            </span>
          </caption> -->
            <thead>
              <tr>
                <th>Pass Type</th>
                <th>Description</th>
                <th
                  v-for="range in prices[0].ranges"
                  :key="range.passtype"
                  style="text-align:center"
                >
                  {{ range.dates }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="type in prices" :key="type.passtype">
                <td scope="row" style="text-align:left">{{ type.passtype }}</td>
                <td scope="row" style="text-align:left">
                  {{ type.description }}
                </td>
                <td v-for="range in type.ranges" :key="range.dates">
                  {{ range.price }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card-text>
      <div
        v-if="pricingDescriptions"
        class="card card-body bg-light small text-left"
      >
        <p
          v-for="(description, index) in pricingDescriptions[0].paragraphs"
          :key="index"
          v-html="description"
        ></p>
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["passtypes", "parkname", "pricingDescriptions"],
  computed: {
    prices() {
      let prices = [];
      this.passtypes.forEach(passtype => {
        let price = {
          passtype: passtype.name,
          description: passtype.used_for,
          ranges: []
        };
        //For each pass type, grab each period
        passtype.periods.forEach(period => {
          let periodYear = moment.utc(period.start_date).year();

          let division = null;
          //If current year, get active division
          if (periodYear == moment().year()) {
            division = period.divisions.find(div => {
              let end = moment(div.ends_at + "-" + periodYear, "MM-DD-YYYY");
              if (moment() <= end) {
                return div;
              }
            });
          } else {
            period.divisions.sort((a, b) => {
              let first = moment(a.starts_at + "-" + periodYear, "MM-DD-YYYY");
              let second = moment(b.starts_at + "-" + periodYear, "MM-DD-YYYY");
              return first - second;
            });
            division = period.divisions[0];
          }
          let datesDisplay = periodYear;
          if (passtype.periods.length == 1) {
            datesDisplay = "Price";
          }

          let pricerange = {
            dates: datesDisplay,
            price: division.display_price
          };
          price.ranges.push(pricerange);
        });
        prices.push(price);
      });
      return prices;
      //Return Division Date Range and Prices per passtype
    }
  }
};
</script>
